module.exports = __webpack_public_path__ + "static/media/jdyf_geren_icon.a4631427.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jdyf_geren_icon.png
// module id = 402
// module chunks = 0